import RankTypes from './types';
import { Reducer } from 'redux';
import { BarRankState, BarRankDispatchAction } from './state';

const initialState : BarRankState = {
    rank: ''
}

const RankReducer : Reducer<BarRankState, BarRankDispatchAction> = 
    (state = initialState, action) => {
        switch(action.type) {
            case RankTypes.FETCH_START:
                return state
            case RankTypes.FETCH_SUCCESS:
                return action.payload
            default:
                return state
        }
    }

export default RankReducer;